// src/components/common/chartTooltipStyles.js
//
// Recharts <Tooltip> renders a WHITE card with dark text by default and knows
// nothing about the MUI theme. On the dark dashboards that produced a white
// box floating over a dark chart with barely-legible labels - reported from
// the Balancing Forecast panel on 2026-09-07.
//
// The values below are the ones ModulePerformanceDialog.jsx already used and
// that were already right; this module exists so the third and fourth panel
// share them instead of growing a fourth copy that drifts. That file is
// deliberately left alone - it works, and rewriting a working panel to import
// a constant is risk with no return.
//
// Usage:
//   const theme = useTheme();
//   <Tooltip {...chartTooltipProps(theme.palette.mode === "dark")} ... />

export function chartTooltipProps(isDark) {
  return {
    contentStyle: {
      backgroundColor: isDark ? "#1e293b" : "#ffffff",
      border: isDark ? "1px solid rgba(100,116,139,0.4)" : "1px solid #e2e8f0",
      borderRadius: 8,
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    },
    labelStyle: { color: isDark ? "#94a3b8" : "#475569", fontSize: 12 },
    itemStyle: { color: isDark ? "#e2e8f0" : "#0f172a", fontSize: 13, fontWeight: 600 },
    cursor: {
      stroke: isDark ? "rgba(148,163,184,0.3)" : "rgba(100,116,139,0.2)",
      strokeWidth: 1,
    },
  };
}
